import { render, staticRenderFns } from "./ConsultaRealizada.vue?vue&type=template&id=4ccc2633&scoped=true&"
import script from "./ConsultaRealizada.vue?vue&type=script&lang=js&"
export * from "./ConsultaRealizada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc2633",
  null
  
)

export default component.exports